export enum SliderOptions {
  DEFAULT_ITEM_WIDTH = 0,
  SLIDES_POSITION = 0,
  SLIDES_TO_SHOW = 3,
  SLIDES_TO_SCROLL = 1,
  SLIDES_GAP = 30,
}
